module.exports = __webpack_public_path__ + "static/media/sc.33377620.svg";